import { FormValues } from './SpecialLeaveTab.types';

export const NOMINAL_DUTY_FIELDS = [
  { key: 'special_leave_importCode', value: 'specialLeaveImportCode' },
  { key: 'special_leave_dutyHourTypeId', value: 'specialLeaveDutyHourTypeId' },
  { key: 'special_leave_percentage', value: 'specialLeavePercentage' },
  {
    key: 'special_leave_processAsNegative',
    value: 'specialLeaveProcessAsNegative'
  },
  { key: 'special_leave_period', value: 'specialLeavePeriod' }
] as const satisfies readonly {
  key: string;
  value: keyof FormValues;
}[];
